module.exports = __webpack_public_path__ + "static/media/clock.918fe561.svg";